import { useEffect } from 'react';
import { useStore } from 'zustand';
import { DataTestIdEnum } from '@medprev-web-app/datatestid';

import { AllSearchResults, SearchType } from '@/app/(main)/_components/search-modal/search-modal.types';
import { FiltersTabs } from '@/components/ui/filters-tab.component';
import { setSelectedFilter, useSearchState } from '@/store/search/search.store';
import { getAnalyticsPlugin } from '@/app/(main)/_components/logger/analytics/get-analytics-plugin';
import { AnalyticsEnum } from '@/types/enums/analytics/analytics.enum';
import { SelectedProcedures } from '@/app/(main)/_components/search-modal/search-modal.types';
import { OverridedUserLocation } from '@/utils/formatters/city/format-place-from-slug.const';

interface SearchFiltersProps {
  results: AllSearchResults;
  locationOverride?: OverridedUserLocation;
  className?: string;
  selectLaboratoryProcedure?: (procedure: SelectedProcedures) => void;
}

const all_tabs = [
  { value: SearchType.ALL, label: 'Todos' },
  { value: SearchType.PROCEDURE, label: 'Atendimentos' },
  { value: SearchType.PROFESSIONAL, label: 'Profissionais' },
  { value: SearchType.PARTNER, label: 'Locais' },
];

export function SearchFilters({
  results,
  className,
}: SearchFiltersProps) {
  const tabs = all_tabs
    .filter((tab) => {
      return results[tab.value as keyof AllSearchResults].results.length > 0;
    })
    .filter((tab, _, array) => {
      return array.length == 2 ? tab.value !== SearchType.ALL : true;
    });

  const selectedFilter = useStore(useSearchState, (state) => state?.selectedFilter);
  const onlyTab = tabs.length === 1 ? tabs[0].value : undefined;

  useEffect(() => {
    if (onlyTab && selectedFilter !== onlyTab) {
      setSelectedFilter(onlyTab);
    }
  }, [onlyTab, selectedFilter]);

  const activeTab = selectedFilter && tabs.some((tab) => tab.value === selectedFilter)
    ? selectedFilter
    : (onlyTab ?? SearchType.ALL);

  const handleTabChange = (value: string) => {
    setSelectedFilter(value);
    getAnalyticsPlugin().track(AnalyticsEnum.CLICK_SEARCH_MODAL_CATEGORY, {
      categoria: value.toLocaleLowerCase(),
    });
  };

  return (
    <div
      className={className}
      data-testid={DataTestIdEnum.PROCEDURES_MODAL_SEARCH_FILTERS}
    >
      <FiltersTabs
        tabs={tabs}
        value={activeTab}
        onChange={handleTabChange}
      />
    </div>
  );
}
